<avi-state-page>
    <avi-state-page_main-content>
        <avi-page-header headerText="{{ l10nKeys.headerLabel | vtranslate }}"></avi-page-header>
        <avi-alert-group
            *ngIf="newCrsInfo"
            alertType="info"
            [closable]="true"
            class="waf-crs-list-page__new-release-alert"
        >
            <span> {{ l10nKeys.newReleaseLabel | vtranslate : newCrsInfo.name }} </span>
            <a href="{{ newCrsInfo.url }}">
                {{ l10nKeys.downloadButtonLabel | vtranslate }}
            </a>
        </avi-alert-group>
        <avi-card
            [noBodyPadding]="true"
            [useContentHeight]="true"
        >
            <avi-card_body>
                <div class="waf-crs-list-page__upload-crs">
                    <avi-input-container
                        [noMarginTop]="true"
                        helperText="{{ l10nKeys.uploadCrsFileHelperText | vtranslate }}"
                    >
                        <label
                            aviLabelWithTooltip
                            for="upload-waf-crs"
                        >
                            {{ l10nKeys.uploadCrsFileLabel | vtranslate }}
                        </label>
                        <async-file-upload
                            name="upload-waf-crs"
                            id="upload-waf-crs"
                            [(ngModel)]="file"
                            (ngModelChange)="handleFileChange()"
                            [(fileName)]="fileName"
                            (onFileUpload)="handleFileUpload()"
                            [maxFileSize]="10"
                            [decodeFile]="true"
                            [error]="error"
                            [loadingState]="loadingState"
                            accept=".json"
                        ></async-file-upload>
                    </avi-input-container>
                </div>
            </avi-card_body>
        </avi-card>
        <avi-collection-data-grid
            [config]="wafCrsGridConfig"
            class="waf-crs-list-page__grid"
        >
            <ng-template
                #expandedContentTemplateRef
                let-row
            >
                <div class="waf-crs-list-page__expander-content">
                    <pre>{{ row.getConfig().description }}</pre>
                </div>
            </ng-template>
        </avi-collection-data-grid>
    </avi-state-page_main-content>
</avi-state-page>
